<template>
  <el-container :style="backStyle" id="Login">
    <el-header height="90px">
      <div class="logo-container">
        <img :src="logo" v-if="showLogo" />
        <span>{{ companyName }}</span>
      </div>
    </el-header>
    <el-main>
      <div class="login-card__container fullheight">
        <div class="login-div">
          <el-form style="margin: 30px" :model="principal" :rules="rules" ref="principal">
            <div class="cLogo">
              <img :src="logo_colored" v-if="showLogo" />
            </div>
            <div class="welcome-title">{{ companyName }}</div>
            <el-form-item prop="account">
              <el-input size="medium" clearable placeholder="请输入您的用户名" prefix-icon="el-icon-login-user" v-model="principal.account"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                clearable
                prefix-icon="el-icon-login-pwd"
                placeholder="请输入您的密码"
                @keyup.enter.native="submitForm('principal')"
                @focus="inputGetFocus"
                size="medium"
                v-model="principal.password"
              ></el-input>
            </el-form-item>
            <!-- <el-alert
              v-if="responseError"
              :title="responseError"
              type="error"
              :closable="false"
            ></el-alert> -->
            <el-row class="smallPart">
              <el-col :span="12">
                <el-checkbox v-model="remember">记住密码</el-checkbox>
              </el-col>
              <el-col :span="12">
                <!-- <el-button
                  @click="resetForm('principal')"
                  :disabled="loading"
                  class="resetBtn"
                  >重置密码</el-button
                > -->
              </el-col>
            </el-row>
            <el-form-item style="text-align: center; margin-top: 10px">
              <el-button class="loginBtn" @focus="inputGetFocus" @click="submitForm('principal')" :loading="loading">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-main>
    <el-footer class="copyright" height="30px">
      <span>Copyright © 2021 iezu易筑 </span>
      <el-divider direction="vertical"></el-divider>
      <span><a type="info" :underline="false" target="_blank" href="https://beian.miit.gov.cn">苏ICP备2021003369号-2</a></span>
      <el-divider direction="vertical"></el-divider>
      <a target="_blank" href="https://beian.miit.gov.cn" style="display: inline-block; text-decoration: none"
        ><img src="../assets/img/beian.png" /> <span> 苏公网安备 32050502000902号 </span></a
      >
      <el-divider direction="vertical"></el-divider>
      <span>增值电信业务经营许可证：苏B2-20221063</span>
    </el-footer>
  </el-container>
</template>

<script>
import { Message } from 'element-ui'

export default {
  name: 'login',
  data() {
    var checkAccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入账号'))
      }
      if (/^[a-zA-Z0-9_-]{2,200}$/.test(value)) {
        return callback()
      } else {
        return callback(new Error('账号格式不符合规范'))
      }
    }
    return {
      logo: require('@/assets/img/logo.png'),
      logo_colored: require('@/assets/img/80.png'),
      showTenant: false,
      showLogo: true,
      remember: false,
      companyName: '易筑网络科技（苏州）有限公司',
      tenantName: '',
      principal: {
        tenantId: '',
        account: '',
        password: ''
      },
      rules: {
        account: [{ validator: checkAccount, trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      responseError: '',
      loading: false,
      backStyle: {
        width: '100%',
        background: `url(${require('@/assets/img/loginBg.jpg')}) center / 100% no-repeat`,
        backgroundSize: 'cover'
      },
      isIeExplorer: false
    }
  },
  // 进入页面清除session
  beforeCreate() {
    sessionStorage.clear()
  },
  mounted() {
    this.getCookie()
    //获取租户信息，域名的后缀
    let tenant = this.$route.params.tenant
    if (typeof tenant === 'undefined' || tenant === null || tenant === '') {
      tenant = this.getTenantCode()
    } else {
      this.$store.dispatch('tenant/actionTenantCode', tenant)
    }
    if (tenant) {
      this.showLogo = false
      let url = '${uc}/uc/tenantManage/v1/getTenantByCode?code=' + tenant
      let _this = this
      this.$http.get(url).then((resp) => {
        if (resp.data) {
          _this.$store.dispatch('tenant/actionTenantId', resp.data.id)
          _this.$store.dispatch('tenant/actionCurrentTenantId', resp.data.id)
          _this.$store.dispatch('tenant/actionTenantName', resp.data.name)
          _this.$store.dispatch('login/loginTenantName', resp.data.name)
          let tenantManage = resp.data
          _this.showTenant = true
          _this.companyName = tenantManage.name
          _this.principal.tenantId = tenantManage.id
          if (tenantManage.ico) {
            let ico = JSON.parse(tenantManage.ico)
            if (ico && ico.length > 0) {
              _this.showLogo = true
              _this.logo = window.context.portal + '/system/file/v1/downloadFile?fileId=' + ico[0].id
              _this.logo_colored = window.context.portal + '/system/file/v1/downloadFile?fileId=' + ico[0].id
            }
          }
        }
      })
    }
  },
  methods: {
    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date() //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) //保存的天数
      //字符串拼接cookie
      window.document.cookie = 'userName' + '=' + c_name + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie = 'userPwd' + '=' + c_pwd + ';path=/;expires=' + exdate.toGMTString()
    },
    // 读取cookie
    getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ') //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'userName') {
            this.principal.account = arr2[1] //保存到保存数据的地方
          } else if (arr2[0] == 'userPwd') {
            this.principal.password = arr2[1]
          }
        }
      }
    },
    //清除cookie
    clearCookie() {
      this.setCookie('', '', -1) //修改2值都为空，天数为负1天就好了
    },
    querySearch(queryString, cb) {
      if (!queryString) {
        return cb([])
      }
      let queryFilter = {}
      queryFilter.pageBean = {
        page: 1,
        pageSize: 20,
        total: 0,
        showTotal: true
      }
      let query = {
        property: 'name_',
        value: queryString,
        group: 'main',
        operation: 'LIKE',
        relation: 'AND'
      }
      if (!queryFilter.querys) {
        queryFilter.querys = []
      }
      queryFilter.querys.push(query)

      this.$http.post(`${window.context.uc}/uc/tenantManage/v1/listJson`, queryFilter).then((res) => {
        // 调用 callback 返回建议列表的数据
        cb(res.data.rows)
      })
    },
    handleSelect(item) {
      this.tenantName = item.name
      this.principal.tenantId = item.id
    },
    setRouterPath() {
      this.$store.dispatch('login/actionLoginAccount', this.principal.account)
      localStorage.setItem(this.principal.account + 'loginRoutePath', this.$route.path)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.inputGetFocus()
          if (this.remember == true) {
            //传入账号名，密码，和保存天数3个参数
            this.setCookie(this.principal.account, this.principal.password, 7)
          } else {
            //清空Cookie
            this.clearCookie()
          }
          this.loading = true
          this.setRouterPath()
          this.$store
            .dispatch('login/loginByPrincipal', {
              username: this.principal.account,
              password: this.principal.password,
              tenantId: this.principal.tenantId ? this.principal.tenantId : '-1',
              grant_type: 'password',
              account_type: 'evo'
            })
            .then((loginStatus) => {
              this.loading = false
              if (loginStatus && loginStatus == true) {
                localStorage.removeItem('activeAlias')
                this.$store.dispatch('login/setCurUser', this.principal.account).then(() => {
                  this.$store.dispatch('user/loadCurrentUserDetail').then(() => {
                    // 获取下老系统jwt
                    this.$store.dispatch('login/loginV2Token', this.principal.account)
                    this.$store.dispatch('menu/actionMenus').then((data) => {
                      if (!data || (data && data.length === 0)) {
                        Message.error('您的账号未分配任何菜单权限,请联系管理员')
                        this.$store.dispatch('login/logoutAndCleanUp')
                        return false
                      }
                      if (this.$route.query.redirect) {
                        this.$router.push({
                          path: this.$route.query.redirect
                        })
                      } else {
                        // 先找下二级菜单是否存在
                        if (data[0].children && data[0].children.length > 0) {
                          this.$router.push({ name: data[0].children[0].alias })
                        } else {
                          this.$router.push({ name: data[0].alias })
                        }
                      }
                    })
                  })
                })
              } else if (loginStatus == false) {
                this.$router.push({
                  name: 'resetPwdView',
                  params: { account: this.principal.account }
                })
              }
            })
            .catch((msg) => {
              this.loading = false
              if (msg.startsWith('timeout of')) {
                msg = '登录超时'
              }
              // this.responseError = msg;
            })
        } else {
          return false
        }
      })
    },
    inputGetFocus() {
      this.responseError = ''
    },
    resetForm(formName) {
      this.responseError = ''
      this.$refs[formName].resetFields()
    },
    getTenantCode() {
      console.info(window.location.hostname)
      let hostname = window.location.hostname
      if (hostname && hostname.indexOf('.') > 0) {
        let domainCode = hostname.split('.')[0]
        let baseDomain = `${window.context.manage}`
        if (baseDomain.indexOf(domainCode) < 0) {
          if (domainCode.indexOf('-') > 0) {
            return domainCode.split('-')[0]
          } else {
            return domainCode
          }
        }
      }
      return ''
    }
  },
  created() {
    let USER_AGENT = navigator.userAgent.toLowerCase()
    let isChrome = /.*(chrome)\/([\w.]+).*/
    if (!isChrome.test(USER_AGENT)) {
      this.isIeExplorer = true
    }
  },
  components: {}
}
</script>
<style lang="scss">
@import '@/assets/css/element-variables.scss';
#Login {
  .login-card__container {
    display: flex;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .el-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo-container {
      display: flex;
      align-items: center;
      img {
        height: 48px;
      }
      span {
        font-size: 18px;
        font-weight: bold;
        color: #fff;
        margin-left: 12px;
      }
    }
  }

  .logo-container > i.icon-eco-H-c {
    font-size: 36px;
    background-image: linear-gradient($--color-secondary, $--color-primary);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    margin-right: -5px;
  }

  .logo-container > i.icon-eco-H-ie {
    font-size: 36px;
    background-clip: text;
    -webkit-background-clip: text;
    color: $--color-primary;
    margin-right: -5px;
  }

  .logo-container:hover > i.icon-eco-H-c {
    background-image: linear-gradient($--color-primary, $--color-secondary);
  }

  .logo-container > span.pre-word {
    font-size: 26px;
    font-weight: bold;
    color: $--color-primary;
  }

  .logo-container > span.tail-word {
    font-size: 24px;
    font-weight: bold;
    color: #bdbfc2;
  }

  .logo-container > .logo-divider {
    margin: 0 25px 11px 25px;
    height: 18px;
  }

  .logo-container > .system-name {
    color: #666;
    font-weight: bold;
    font-size: 16px;
  }

  .site-div {
    float: right;

    margin-top: 25px;
    margin-right: 40px;
  }

  .site-div > a {
    color: #5b9dff;
    font-size: 12px;
    text-decoration: none;
  }

  .site-div > a > i {
    font-weight: bold;
    margin-right: 5px;
  }

  .login-card {
    width: 600px;
    height: 320px;
  }

  .totem-div {
    -moz-box-shadow: 2px 2px 5px #999;
    -webkit-box-shadow: 2px 2px 5px #999;
    box-shadow: 2px 2px 5px #999;
  }

  .login-div {
    width: 400px;
    background-color: white;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    border: 1px solid #cbcbcb;
    border-radius: 15px;
  }
  .cLogo {
    text-align: center;
    padding-top: 20px;
    img {
      width: 65px;
    }
  }

  .el-icon-login-user {
    background: url(../assets/img/user.png) center no-repeat;
    background-size: 16px 16px;
  }
  .el-icon-login-pwd {
    background: url(../assets/img/pwd.png) center no-repeat;
    background-size: auto 16px;
  }
  .welcome-title {
    margin-top: 10px;
    margin-bottom: 60px;
    font-size: 18px;
    font-weight: bolder;
    text-align: center;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 28px;

    .el-input--medium /deep/ .el-input__inner {
      height: 40px;
      line-height: 40px;
    }

    .el-button {
      padding: 10px 32px;

      & /deep/ span {
        font-size: 16px;
      }
    }

    /deep/ .el-button + .el-button {
      margin-left: 20px;
    }

    .el-input--medium {
      /deep/ .el-input__icon {
        font-size: 16px;
        line-height: 40px;
      }
    }
  }

  .copyright {
    color: #fff;
    font-size: 13px;
    text-align: center;
  }

  >>> .el-card__body {
    padding: 0;
  }
  .resetBtn {
    background: none;
    border: 0;
    color: #357cfe;
    float: right;
    padding: 0;
    line-height: 19px;
    font-size: 14px;
  }
  .loginBtn {
    width: 100%;
    height: 40px;
    background: #357cfe;
    font-weight: bolder;
    color: #fff;
    margin-bottom: 40px;
  }
  .smallPart {
    margin-top: -10px;
    margin-bottom: 20px;
  }
  .login-card /deep/ .el-alert__content {
    padding: 5px;
  }
  .copyright {
    position: fixed;
    width: 100%;
    bottom: 20px;
    color: #fff;
    font-size: 13px;
    text-align: center;
    img {
      width: 16px;
      position: relative;
      top: 2px;
    }
    span,
    a {
      color: #fff;
      text-decoration: none;
    }
  }
}
</style>
